/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { roundDependencies } from './dependenciesRound.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createFloor } from '../../factoriesAny.js';
export var floorDependencies = {
  roundDependencies: roundDependencies,
  typedDependencies: typedDependencies,
  createFloor: createFloor
};